import { render } from "./phone-preview.component.vue?vue&type=template&id=7ec91323"
import script from "./phone-preview.component.vue?vue&type=script&lang=js"
export * from "./phone-preview.component.vue?vue&type=script&lang=js"

import "./phone-preview.component.vue?vue&type=style&index=0&id=7ec91323&lang=css"

import exportComponent from "/mnt/ssd2/projects/techno2_remaster/client_ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__